/// [Specs](#model.MarkSpec) for the marks in the schema.
import {DOMOutputSpec, MarkSpec} from 'prosemirror-model';

export let code_spec = {
  parseDOM: [{tag: 'code'}],
  toDOM() {
    return ['code', 0];
  },
} as MarkSpec;
